import { defineStore } from 'pinia';
import { computed, nextTick, ref, watch } from 'vue';
import { useExpressionStore } from './expressions';
import dayjs from 'dayjs';

export type ILanguage = 'sv' | 'en' | 'no' | 'da' | 'fi';

export const useAppStore = defineStore('app', () => {
    let savedLanguage = (localStorage.getItem('app-language') || 'sv') as ILanguage;

    const language = ref<ILanguage>(savedLanguage);
    const requests = ref<{ url: string; number: number }[]>([]);
    const title = ref<string>('');

    const loading = computed(() => requests.value.length > 0);
    const loadingUrls = computed(() => requests.value.map((r) => r.url));

    watch(
        language,
        () => {
            console.log('Language changed to', language.value);
            localStorage.setItem('app-language', language.value);

            document.documentElement.lang = language.value === 'no' ? 'nb' : language.value;

            dayjs.locale(language.value === 'no' ? 'nb' : language.value);

            nextTick(() => {
                let expression = useExpressionStore();
                expression.getExpressions(language.value);
            });
        },
        { immediate: true }
    );

    const loadingUrlsIncludes = (url: string) => {
        return loadingUrls.value.includes(url);
    };

    const requestStarted = (requestNumber: number, url: string) => {
        requests.value.push({ url, number: requestNumber });
    };

    const requestEnded = (requestNumber: number) => {
        let index = requests.value.findIndex((r) => r.number === requestNumber);
        requests.value.splice(index, 1);
    };

    return {
        language,
        requestStarted,
        requestEnded,
        title,
        loading,
        loadingUrls,
        loadingUrlsIncludes,
        requests,
    };
});
